let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("grTt5")).then(() => parcelRequire('g9KH3'));